import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  withStyles,
  Typography,
  Grid,
  Button,
  Popover,
} from '@material-ui/core';
import NavBar from '../../nav/NavBar';
import Footer from '../../footer/Footer';
import FooterSpacer from '../../footer/FooterSpacer';

import whiteBelt from './WhiteBelt';
import greenBelt from './GreenBelt';
import blueBelt from './BlueBelt';
import brownBelt from './BrownBelt';
import blackBelt from './BlackBelt';
import firstDegree from './FirstDegreeBlackBelt';
import secondDegree from './SecondDegreeBlackBelt';

import quoteImg from '../../../static/img/events_page/quote.png';
// import Placeholder from '../../../static/img/training_types_pages/placeholder.png';

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  buttonSectionHeader: {
    marginBottom: theme.spacing(2),
    fontSize: '1em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  costLabel: {
    display: 'inline',
    textTransform: 'uppercase',
  },
  discoverHeaderContainer: {
    paddingBottom: theme.spacing(4),
  },
  discoverButtonContainer: {
    height: '100%',
  },
  discoverButton: {
    margin: theme.spacing(),
  },
  discoverHeader: {
    fontSize: '2.125rem',
    position: 'relative',
    top: '10px',
    width: '100%',
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  discoverHeaderSmall: {
    fontSize: '1.5rem',
    position: 'relative',
    top: '10px',
    width: '100%',
    textAlign: 'left',
    textTransform: 'uppercase',
  },
  discoverSectionText: {
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
  hero: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  header: {
    position: 'relative',
    top: '10px',
    width: '100%',
    textAlign: 'left',
    textTransform: 'uppercase',
    [theme.breakpoints.down(800)]: {
      top: '7px',
      fontSize: '2.5em',
    },
  },
  heroImg: {
    height: 'auto',
    width: '100%',
  },
  keyWordContainer: {
    margin: 'auto',
  },
  keyWord: {
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    fontSize: '2em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  section: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  stockImg: {
    padding: theme.spacing(2),
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
    width: '100%',
    height: 'auto',
    maxHeight: '100%',
    // transform: 'translateX(-50%)',
  },
  sectionText: {
    paddingBottom: theme.spacing(2),
  },
  sectionHeader: {
    marginBottom: theme.spacing(2),
    fontSize: '2em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  tabsButton: {
    letterSpacing: '1px',
    paddingLeft: theme.spacing(),
    paddingRight: theme.spacing(),
    fontSize: '.8em',
  },
  button: {
    marginTop: theme.spacing(2),
  },
  policyButton: {
    marginTop: theme.spacing(),
  },
  cost: {
    display: 'inline-block',
    marginBottom: theme.spacing(2),
    fontSize: '1.5em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
    float: 'right',
  },
  costPrice: {
    display: 'inline-block',
    fontSize: '1.5em',
    letterSpacing: '1px',
  },
  priceContainer: {
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
  },
  quoteImg: {
    width: '95%',
    padding: theme.spacing(2),
  },
  quote: {
    letterSpacing: '1px',
    fontSize: '1.2em',
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  quoteAuthor: {
    textAlign: 'right',
    fontWeight: 'bold',
  },
  divider: {
    marginBottom: theme.spacing(2),
  },
  popoverSection: {
    maxWidth: '100%',
    padding: theme.spacing(3),
  },
  hr: {
    [theme.breakpoints.down(800)]: {
      display: 'none',
    },
  },
});


const trainingLevels = {
  whiteBelt,
  greenBelt,
  blueBelt,
  brownBelt,
  blackBelt,
  firstDegree,
  secondDegree,
};

const BodyLifeTrainings = ({ classes }) => {
  // Get trainingLevel param. Accepts any of trainingLevels. Defaults to 'whiteBelt'.
  const { trainingType } = useParams();
  // Check validity of route param and provide default
  const startingTrainingType = Object.keys(trainingLevels).includes(trainingType) ? trainingType : 'whiteBelt';

  const [currentTab, setCurrentTab] = useState(startingTrainingType);
  const [currentTrainingLevel, setCurrentTrainingLevel] = useState(trainingLevels[currentTab]);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [registrationOpen, setRegistrationOpen] = useState(false);

  const handleClick = (e, tab) => {
    setCurrentTab(tab);
    setCurrentTrainingLevel(trainingLevels[tab]);
  };

  return (
    <div className={classes.page}>
      <NavBar />
      <main className={classes.container}>
        <div className={classes.appBarSpacer} />
        <div className={classes.content}>
          <div className={classes.section}>
            <Grid container>
              <Grid item xs={12}>
                <Typography color="textSecondary" variant="h1" className={classes.sectionHeader}>Body + Life Training</Typography>
                <hr className={classes.divider} />
              </Grid>
              <Grid item xs={12}>
                <Button variant={currentTab === 'whiteBelt' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'whiteBelt')}>White Belt</Button>
                <Button variant={currentTab === 'greenBelt' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'greenBelt')}>Green Belt</Button>
                <Button variant={currentTab === 'blueBelt' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'blueBelt')}>Blue Belt</Button>
                <Button variant={currentTab === 'brownBelt' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'brownBelt')}>Brown Belt</Button>
                <Button variant={currentTab === 'blackBelt' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'blackBelt')}>Black Belt</Button>
                <Button variant={currentTab === 'firstDegree' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'firstDegree')}>First Degree</Button>
                <Button variant={currentTab === 'secondDegree' ? 'contained' : 'text'} color="secondary" className={classes.tabsButton} onClick={e => handleClick(e, 'secondDegree')}>Second Degree</Button>
              </Grid>
            </Grid>
          </div>
          <div className={classes.hero}>
            <img className={classes.heroImg} alt={currentTrainingLevel.headerAlt} src={currentTrainingLevel.hero} />
          </div>
          <div className={classes.section}>
            <Grid container>
              <Grid item xs={12} sm={6}>
                <Typography variant="h2" color="textSecondary" className={classes.sectionHeader}>{currentTrainingLevel.overviewHeader}</Typography>
                <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.overviewDescription}</Typography>
              </Grid>
              <hr className={classes.hr} />
              <Grid item className={classes.keyWordContainer} xs={12} sm={5}>
                <Typography variant="h3" color="textSecondary" className={classes.keyWord}>{currentTrainingLevel.keyWord}</Typography>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={12} sm={5}>
                <img src={quoteImg} alt="quote" className={classes.quoteImg} />
              </Grid>
              <Grid item xs={12} sm={7}>
                <Typography variant="h3" className={classes.quote}>{currentTrainingLevel.quote}</Typography>
                <Typography className={classes.quoteAuthor}>{'-' + currentTrainingLevel.quoteAuthor}</Typography>
              </Grid>
            </Grid>
          </div>
          <div className={classes.video}>
            <img className={classes.heroImg} alt={currentTrainingLevel.subHeaderAlt} src={currentTrainingLevel.subhero} />
          </div>
          <div className={classes.section}>
            <Grid container>
              <Grid item xs={12} className={classes.discoverHeaderContainer}>
                <Typography variant="h4" color="textSecondary" className={classes.discoverHeaderSmall}>Discover...</Typography>
                <Typography variant="h3" color="textSecondary" className={classes.discoverHeader}>{currentTrainingLevel.discover}</Typography>
              </Grid>
              <Grid item xs={12} sm={5}>
                <img className={classes.stockImg} alt={currentTrainingLevel.stockImgAlt} src={currentTrainingLevel.stockImg} />
              </Grid>
              <Grid item xs={12} sm={7}>
                <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.goalDescription}</Typography>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography variant="h1" color="textSecondary">1</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body1" className={classes.discoverSectionText}>{currentTrainingLevel.goal1}</Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography variant="h1" color="textSecondary">2</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body1" className={classes.discoverSectionText}>{currentTrainingLevel.goal2}</Typography>
                  </Grid>
                </Grid>
                <Grid container>
                  <Grid item xs={2}>
                    <Typography variant="h1" color="textSecondary">3</Typography>
                  </Grid>
                  <Grid item xs={10}>
                    <Typography variant="body1" className={classes.discoverSectionText}>{currentTrainingLevel.goal3}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div className={classes.section}>
            <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} className={classes.buttonContainer} align="center">
                <Typography variant="body1" color="textSecondary" className={classes.buttonSectionHeader}>{currentTrainingLevel.requirement}</Typography>
                <div align="center" className={classes.discoverButtonContainer}>
                  <Button variant="outlined" color="secondary" className={classes.discoverButton} href="/finder/training">Find a Training</Button>
                </div>
              </Grid>
              <hr />
              <Grid item className={classes.priceContainer} xs={12} sm={5}>
                <Typography variant="body1" color="textSecondary" className={classes.costLabel}>Cost: </Typography>
                <Typography variant="h5" className={classes.cost}>{`${currentTrainingLevel.cost} USD`}</Typography>
                <div className={classes.buttonContainer} align="center">
                  <Button
                    className={classes.policyButton}
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={() => setPaymentOpen(true)}
                  >
                    Payment Policy
                  </Button>
                  <Popover
                    open={paymentOpen}
                    onClose={() => setPaymentOpen(false)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div className={classes.popoverSection}>
                      <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.payment1}</Typography>
                      <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.payment2}</Typography>
                    </div>
                  </Popover>
                  <Button
                    className={classes.policyButton}
                    fullWidth
                    variant="contained"
                    color="secondary"
                    onClick={() => setRegistrationOpen(true)}
                  >
                    Registration Policy
                  </Button>
                  <Popover
                    open={registrationOpen}
                    onClose={() => setRegistrationOpen(false)}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                  >
                    <div className={classes.popoverSection}>
                      <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.registration1}</Typography>
                      <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.registration2}</Typography>
                      <Typography variant="body1" className={classes.sectionText}>{currentTrainingLevel.registration3}</Typography>
                    </div>
                  </Popover>
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
        <FooterSpacer />
      </main>
      <Footer />
    </div>
  );
};

BodyLifeTrainings.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BodyLifeTrainings);
